<template>
  <div v-if="!isPrint">
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 내부 비상연락망 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="내부 비상연락망"
      :tableData="[
        { id: 'input1', title: '구분', type: 'text' },
        { id: 'input2', title: '직책', type: 'textarea' },
        { id: 'input3', title: '연락처', type: 'textarea' },
        { id: 'input4', title: '임무 및 역할', type: 'textarea' },
        { id: 'input5', title: '관련 웹사이트', type: 'link' },
      ]"
      v-model="form.inside"
    />

    <!-- 외부 비상연락망 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="외부 비상연락망"
      :tableData="[
        { id: 'input1', title: '구분', type: 'text' },
        { id: 'input2', title: '직책', type: 'textarea' },
        { id: 'input3', title: '연락처', type: 'textarea' },
        { id: 'input4', title: '임무 및 역할', type: 'textarea' },
        { id: 'input5', title: '관련 웹사이트', type: 'link' },
      ]"
      v-model="form.outside"
    />

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
  <print v-else :form="form" />
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import Print from "./Print.vue";

export default {
  components: {
    FieldSelectModule,
    TableCustom,
    FileUploadModule,
    Print,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inside: [
          { id: 1,  input1: "안전보건관리책임자", input2: "구청장", input3: "970-4000" },
          { id: 2,  input1: "비상지휘단장", input2: "재해발생 해당 실국장", input3: "-" },
          { id: 3,  input1: "비상통제단장", input2: "안전관리과장", input3: "970-4680" },
          { id: 4,  input1: "상황지휘 및 총괄지휘반", input2: "재해발생 해당과장(관리감독자)", input3: "-" },
          { id: 5,  input1: "통제지원", input2: "안전관리과장", input3: "970-4680" },
          { id: 6,  input1: "현장대응", input2: "안전관리자, 보건관리자", input3: "970-2904,2905" },
          { id: 7,  input1: "자원지원", input2: "총무과,  \n도시정비과,  \n재무과", input3: "970-4110, \n970-4140, \n970-4640" },
        ],
        outside: [
          { id: 1,  input1: "부산강서경찰서", input2: "182", input3: "명지국제1로 305" },
          { id: 2,  input1: "부산강서소방서", input2: "051)760-5080", input3: "녹산산단361로 9" },
          { id: 3,  input1: "갑을녹산병원", input2: "051)974-8300", input3: "송정동 소재" },
          { id: 4,  input1: "고용노동부 부산본청", input2: "051)853-0009", input3: "연제로 36" },
          { id: 5,  input1: "고용노동부 부산북부지청", input2: "051)309-1500", input3: "백양대로 804" },
          { id: 6,  input1: "한국가스공사", input2: "051)315-5900", input3: "-" },
          { id: 7,  input1: "한국전력공사", input2: "123", input3: "부전2동 소재" },
        ],
        fileList: [],
      },
    };
  },
  created () {
    if (this.value) {
      const keys = Object.keys(this.value);
      for (const key of keys) {
        if (this.value[key]) {
          this.form[key] = this.value[key];
        }
      }
    }
  },
};
</script>
